import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Establishment } from '../../entities/establishment';

@Injectable({ providedIn: 'root' })
export class EstablishmentRepository {
  private get table() {
    return this.db.establishmentTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Establishment[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Establishment(row));
  }

  async getById(locationId: number): Promise<Establishment | undefined> {
    const row = await this.table.get(locationId);
    return row ? new Establishment(row) : undefined;
  }

  async getByZoneId(zoneId: number): Promise<Establishment[]> {
    const rows = await this.table.where('zoneId').equals(zoneId).toArray();
    return rows.map(row => new Establishment(row));
  }

  async getByRegionId(regionId: number): Promise<Establishment[]> {
    const rows = await this.table.where('regionId').equals(regionId).toArray();
    return rows.map(row => new Establishment(row));
  }

  upsert(establishment: Establishment): Promise<number> {
    return this.table.put(establishment);
  }

  upsertBulk(establishments: Establishment[]): Promise<number> {
    return this.table.bulkPut(establishments);
  }

  delete(locationId: number): Promise<void> {
    return this.table.delete(locationId);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}
